// User Info
export const GET_USER_INFO = 'USER/GET_USER_INFO'
export const SET_USER_INFO = 'USER/SET_USER_INFO'
export const RESET_USER_INFO = 'USER/RESET_USER_INFO'

// Fetch States
export const GET_USER_INFO_FETCH_START = 'USER/GET_USER_INFO_FETCH_START'
export const GET_USER_INFO_FETCH_FAIL = 'USER/GET_USER_INFO_FETCH_FAIL'
export const GET_USER_INFO_FETCH_END = 'USER/GET_USER_INFO_FETCH_END'

// Update User
export const UPDATE_USER = 'USER/UPDATE_USER'
export const UPDATE_USER_LOCALE = 'USER/UPDATE_USER_LOCALE'
